import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-ums",
  "use": "icon-ums-usage",
  "viewBox": "0 0 33.792 39.977",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 33.792 39.977\" id=\"icon-ums\">\n  <path id=\"icon-ums_路径_2973\" data-name=\"路径 2973\" d=\"M156.944,66q9.635,4.524,15.435,5.024a1.546,1.546,0,0,1,1.413,1.54V87.514q-2.039,13.505-16.9,18.463Q141.847,101,140,87.514V72.6a1.546,1.546,0,0,1,1.443-1.543q6-.4,15.5-5.053ZM157,74.037a6.652,6.652,0,0,0-1.385,13.146l.045,9.425v.032a1.339,1.339,0,0,0,2.678-.045L158.33,94.9l2.381-.006h.032a1.339,1.339,0,0,0-.038-2.678l-2.387.006-.006-1.241,2.4-.006h.032A1.339,1.339,0,0,0,160.7,88.3L158.3,88.3l-.005-1.1A6.652,6.652,0,0,0,157,74.037Zm0,2.679a3.97,3.97,0,0,1,.412,7.913,1.344,1.344,0,0,0-.9-.009,3.971,3.971,0,0,1,.489-7.9Z\" transform=\"translate(-140 -66)\" fill=\"\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/ums.svg
// module id = J4x9
// module chunks = 19